import { useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import "./login.css";
import LoadingOverlay from "react-loading-overlay";
import { login } from "../../axios/login.axios";
import { message } from "antd";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import axios from "../../axios/axios";
import { products } from "../../products/products.details";
import UpdatePlanLoveTravels from "../signup/update-plan-love-travels";
import { setLoginRedirectDetails } from "../../actions/loginRedirection.action";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useSubdomain } from "../../hooks/useSubdomain";
const LoginPage = (props) => {
  const { hasSubdomain, subdomain, subdomainUrl, primaryUrl } = useSubdomain();
  const history = useHistory();
  const dispatch = useDispatch();
  const [showLoader, setShowLoader] = useState(false);
  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  

  const [showModal, setShowModal] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [modalshowUpdate, setmodalshowUpdate] = useState(false);
  const [modalPlan, setmodalPlan] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [role, setRole] = useState("individual");

  useEffect(() => {
    let sso_token = new URLSearchParams(props.location.search).get("sso_token");
    let action = new URLSearchParams(props.location.search).get("action");
    let afterLogout = new URLSearchParams(props.location.search).get("afterLogout");

    if (sso_token) {
      setShowLoader(true);
      let data = {
        token: sso_token,
      };
      axios
        .post(`user/sso_login`, data)
        .then((res) => {
          setShowLoader(false);
          if (res.data.status) {
            message.success(
              "Please wait we are redirecting you to dashboard",
            );
            localStorage.setItem("AuthData", JSON.stringify(data));
            localStorage.setItem("AuthToken", res.data.token);
            localStorage.setItem("afterLogout", afterLogout);
            localStorage.setItem("userDetails", JSON.stringify(res.data.data));
            localStorage.setItem(
              "clientDetails",
              JSON.stringify(res.data.clientDetails),
            );
            localStorage.setItem(
              "serviceAccess",
              JSON.stringify(res.data.serviceAccess),
            );
            localStorage.setItem("GPTtoken", res.data.GPTtoken);
            setTimeout(() => {
              window.open("/", "_self");
            }, 1000);
          } else {
            message.error("login failed");
          }
        })
        .catch((err) => {
          setShowLoader(false);
          console.log("err", err);
          message.error(err.response.data.message);
        });
    } else if (localStorage.getItem("AuthToken")) {
      localStorage.getItem("AuthToken");
      window.open("/", "_self");
    } else if (action && action === "logout") {
      message.success("You have been successfully logged out");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [null]);

  const loginUser = async (e) => {
    e.preventDefault();

    setShowLoader(true);

    let data = {
      email: user.email,
      password: user.password,
      source: "tvi",
    };

    await login(data)
      .then((data) => {
        // setShowLoader(false);
        // message.success("login successfully");
        // console.log(data,"rrrrrrrrrrrrrrrrrrrrr");
        //   dispatch(setLoginRedirectDetails(data));
        // localStorage.setItem("AuthData", JSON.stringify(data));
        // localStorage.setItem("AuthToken", data.token);
        // localStorage.setItem("userDetails", JSON.stringify(data.data));
        // localStorage.setItem(
        //   "clientDetails",
        //   JSON.stringify(data.clientDetails),
        // );
        // localStorage.setItem(
        //   "serviceAccess",
        //   JSON.stringify(data.serviceAccess),
        // );
        // localStorage.setItem("GPTtoken", data.GPTtoken);
        // window.open("/", "_self");
        // window.open(`${window.location.protocol}//${data.clientDetails?.corporateClientWebsitePrefix}.${window.location.host}/login-redirect`, "_self");


        // history.replace(url);

        const subdomain = data.clientDetails?.corporateClientWebsitePrefix;

        const url = `${window.location.protocol}//${subdomain}.${window.location.host}/login?sso_token=${data.token}&action=login&afterLogout=${window.location.protocol}//${window.location.host}`;

        window.location.replace(url); // ✅ this will work
        // history.replace(`${window.location.protocol}//${data.clientDetails?.corporateClientWebsitePrefix}.${window.location.host}/login-redirect`)
      })
      .catch((err) => {
        setShowLoader(false);
        const { isCanceledSubscription, role } = err;
        setRole(role);
        if (isCanceledSubscription) {
          setmodalshowUpdate(true);
          setPopupMessage(err.message);
        } else {
          message.error(err.message);
        }
      });
  };

  const forgotPassword = (e) => {
    e.preventDefault();

    setShowModal(false);

    axios
      .post("/user/reward-send-reset-password-token", { email: resetEmail })
      .then((res) => {
        if (res.data.status) {
          setResetEmail("");
          message.success("please check your mail");
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        message.error("Something went wrong!!!!");
      });
  };

  const handleModalCloseUpdate = () => {
    setmodalshowUpdate(false);
  };

  const updatePlan = () => {
    setmodalshowUpdate(false);
    setmodalPlan(true);
  };

  const handlePlanModalClose = () => {
    setmodalPlan(false);
  };

  useEffect(() => {
let sso_token = new URLSearchParams(props.location.search).get("sso_token");
    if (hasSubdomain && subdomain) {
      if(!sso_token){
        window.location.replace((primaryUrl === "http://localhost") ? `${primaryUrl}:3000/login` : `${primaryUrl}/login`);
      }
    }
    
    // console.log("hasSubdomain", hasSubdomain, subdomain, subdomainUrl, primaryUrl,(primaryUrl == "http://localhost") ? `${primaryUrl}:3000/login` : `${primaryUrl}/login`);

  },[hasSubdomain, subdomain, subdomainUrl, primaryUrl, props.location.search]);

  return (
    <div>
      <LoadingOverlay
        active={showLoader}
        className="loading_overlay"
        //spinner= <img src={Logo} />
        text=<p>
          Please be patience while we are redirecting to Member Dashboard.
        </p>
      >
        <Modal
          centered
          show={showModal}
          onHide={() => {
            setShowModal(false);
            setResetEmail("");
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Forgot Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={forgotPassword}>
              <Form.Group className="mb-4" controlId="formBasicEmail">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  type="text"
                  className="login_field"
                  placeholder="Enter username"
                  value={resetEmail}
                  onChange={(e) => {
                    setResetEmail(e.target.value);
                  }}
                  required
                />
              </Form.Group>
              <div className="d-flex justify-content-end">
                <Button type="submit" variant="primary">
                  Submit
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>

        <div className="main_cont">
          <div className="login_page">
            <div className="login_page_left"></div>

            <div className="login_page_right">
              <div className="login_inner_bottom text-white">
                <div className="new_user text-center">
                  {/* <h4 className="mb-0">First Time User?</h4> */}
                  {/* <h3 className="signup_link">
                    <Link to="/vip-signup">Create Your Account</Link>
                  </h3> */}
                </div>

                <Form>
                  <Form.Group className="mb-4" controlId="formBasicEmail">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                      type="text"
                      className="login_field"
                      value={user.email}
                      onChange={(e) =>
                        setUser({
                          ...user,
                          email: e.target.value,
                        })
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      className="login_field"
                      value={user.password}
                      onChange={(e) =>
                        setUser({
                          ...user,
                          password: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                  {/* <Form.Group className="mb-3" controlId="formBasicCheckbox">
                  <Form.Check type="checkbox" label="Remember Me" />
                </Form.Group> */}
                  <div className="forgot_pass text-right">
                    <button
                      type="button"
                      onClick={() => {
                        setShowModal(true);
                      }}
                    >
                      Forgot Password?
                    </button>
                  </div>
                  <div className="login_submit text-center">
                    <Button
                      variant="default"
                      type="button"
                      className="btn_light"
                      onClick={loginUser}
                    >
                      Log In
                    </Button>
                    <br />
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>

        <Modal centered show={modalshowUpdate} onHide={handleModalCloseUpdate}>
          <Modal.Body>
            <div className="modal_close">
              <h3>{popupMessage}</h3>
              <Button
                variant="secondary"
                onClick={handleModalCloseUpdate}
                className="close_buuut"
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="footer_but">
            <Button
              variant="secondary"
              onClick={() => {
                updatePlan();
              }}
              className="yesbut"
            >
              Update
            </Button>
            <Button
              variant="primary"
              onClick={handleModalCloseUpdate}
              className="nobut"
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          centered
          show={modalPlan}
          onHide={handlePlanModalClose}
          size="xl"
        >
          <Modal.Body>
            <div className="modal_close">
              <h3>Please choose your plan!</h3>
              <Button
                variant="secondary"
                onClick={handlePlanModalClose}
                className="close_buuut"
              />
            </div>
            <div className="tvi_member_include">
              <UpdatePlanLoveTravels
                products={products}
                currentPackage={0}
                email={user.email}
                role={role}
              />
            </div>
          </Modal.Body>
        </Modal>
      </LoadingOverlay>
    </div>
  );
};

export default LoginPage;
